import Price from "./price";

export default class TotalPrice {

    constructor(currency = {}, taxRate = 1, price = 0, promoPrice = null) {
        this.price = new Price(price);
        this.promoPrice = new Price(promoPrice ? promoPrice : 0);

        this.setCurrency(currency).setTaxRate(taxRate);
    }

    get currentPrice() {
        return this.promoPrice && this.promoPrice.amount > 0 ? this.promoPrice : this.price;
    }

    // Sum two TotalPrice objects
    sum(totalPrice) {
        this.price.add(totalPrice.price.amount);
        this.promoPrice.add(totalPrice.promoPrice.amount);

        return this;
    }

    multiply(multiplier) {
        this.price.amount = this.price.amount * parseFloat(multiplier);
        this.promoPrice.amount = this.promoPrice.amount * parseFloat(multiplier);
    }

    setTaxRate(taxRate) {
        this.promoPrice.taxRate = this.price.taxRate = parseFloat(taxRate);

        return this;
    }

    setCurrency(currency) {
        this.promoPrice.currency = this.price.currency = currency;

        return this;
    }

}
